import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  const updateConsent = (analytics, marketing) => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('consent', 'update', {
      'analytics_storage': analytics ? 'granted' : 'denied',
      'ad_storage': marketing ? 'granted' : 'denied'
    });
  };

  useEffect(() => {
    const consent = localStorage.getItem('cish_cookie_consent');
    if (!consent) {
      setShow(true);
    } else {
      try {
        const parsed = JSON.parse(consent);
        updateConsent(parsed.analytics, parsed.marketing);
      } catch (e) {
        if (consent === 'all') {
          updateConsent(true, true);
        } else if (consent === 'declined') {
          updateConsent(false, false);
        }
      }
    }
  }, []);

  const savePreferences = (prefs) => {
    localStorage.setItem('cish_cookie_consent', JSON.stringify(prefs));
    setShow(false);
    setShowCustomize(false);
    updateConsent(prefs.analytics, prefs.marketing);
  };

  const handleAcceptAll = () => {
    savePreferences({ necessary: true, analytics: true, marketing: true });
  };

  const handleDeclineOptional = () => {
    savePreferences({ necessary: true, analytics: false, marketing: false });
  };

  const handleSaveCustom = () => {
    savePreferences(preferences);
  };

  if (!show) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-[9998] p-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm text-gray-700 flex-1">
          <p className="font-semibold text-gray-900 mb-1">This website uses cookies to provide a better user experience.</p>
          <p>By clicking accept, you agree to the policies outlined in the <a href="/privacy-policy" className="text-red-700 hover:underline">Cookie Settings</a>.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => setShowCustomize(true)} className="px-4 py-2 text-sm font-medium text-red-900 bg-red-50 hover:bg-red-100 rounded transition-colors border border-red-200">
            Customize Cookies
          </button>
          <button onClick={handleDeclineOptional} className="px-4 py-2 text-sm font-medium text-red-900 bg-red-50 hover:bg-red-100 rounded transition-colors border border-red-200">
            Decline Optional Cookies
          </button>
          <button onClick={handleAcceptAll} className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded transition-colors shadow-sm">
            Accept All Cookies
          </button>
        </div>
      </div>

      {showCustomize && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Customize Cookie Preferences</h3>
            
            <div className="space-y-4">
              <div className="flex items-start justify-between border-b border-gray-100 pb-4">
                <div className="pr-4">
                  <h4 className="font-semibold text-gray-900 text-base">Strictly Necessary</h4>
                  <p className="text-sm text-gray-600 mt-1">Essential for the website to function properly. Cannot be disabled.</p>
                </div>
                <div className="pt-1">
                  <input type="checkbox" checked disabled className="h-4 w-4 text-red-600 rounded focus:ring-red-500" />
                </div>
              </div>
              
              <div className="flex items-start justify-between border-b border-gray-100 pb-4">
                <div className="pr-4">
                  <h4 className="font-semibold text-gray-900 text-base">Analytics</h4>
                  <p className="text-sm text-gray-600 mt-1">Help us understand how visitors interact with the website through anonymous analytics (Google Analytics).</p>
                </div>
                <div className="pt-1">
                  <input 
                    type="checkbox" 
                    checked={preferences.analytics} 
                    onChange={(e) => setPreferences({...preferences, analytics: e.target.checked})}
                    className="h-4 w-4 text-red-600 rounded focus:ring-red-500 cursor-pointer" 
                  />
                </div>
              </div>

              <div className="flex items-start justify-between pb-2">
                <div className="pr-4">
                  <h4 className="font-semibold text-gray-900 text-base">Marketing</h4>
                  <p className="text-sm text-gray-600 mt-1">Used to deliver relevant advertisements and track ad performance across third-party websites.</p>
                </div>
                <div className="pt-1">
                  <input 
                    type="checkbox" 
                    checked={preferences.marketing} 
                    onChange={(e) => setPreferences({...preferences, marketing: e.target.checked})}
                    className="h-4 w-4 text-red-600 rounded focus:ring-red-500 cursor-pointer" 
                  />
                </div>
              </div>
            </div>

            <div className="mt-8 flex justify-end gap-3">
              <button 
                onClick={() => setShowCustomize(false)} 
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
              >
                Cancel
              </button>
              <button 
                onClick={handleSaveCustom} 
                className="px-5 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded transition-colors shadow-sm"
              >
                Save Preferences
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
